import React from "react";
import "./Footer.css";
import { FaFacebook, FaInstagram, FaYoutube, FaTiktok, FaGoogle } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        {/* Logo + About */}
        <div className="footer__brand">
          <h2 className="footer__logo">Ads<span>On</span></h2>
          <p>
            AdsOne – We create powerful ad campaigns across TikTok, YouTube,
            Google, Facebook, and Instagram to grow your brand.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer__links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Social Icons */}
        <div className="footer__social">
          <h4>Follow Us</h4>
          <div className="footer__icons">
            <a href="https://www.facebook.com/share/1B9fp6mEGz/"><FaFacebook className="fb-icon" /></a>
            <a href="https://www.instagram.com/adson_uae?igsh=ems5cDR1amRwM2Fh"><FaInstagram className="ig-icon" /></a>
            <a href="#"><FaYoutube className="youtube-icon" /></a>
            <a href="#"><FaTiktok className="tiktok-icon" /></a>
            <a href="#"><FaGoogle className="google-icon" /></a>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>&copy; 2025 SRDigitals. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
